import { useEffect } from 'react';
import { client } from 'graphql/client';
import { useAskForImmediateHelpMutation } from 'graphql-types';
import { isLoggedIn } from 'state/session/helpers';

type OnCompleted = (phoneNumber?: string) => void;

export const useCcsPhoneNumber = (onCompleted?: OnCompleted) => {
  const [askForImmediateHelp, { data }] = useAskForImmediateHelpMutation({
    client,
    onCompleted: data => {
      if (onCompleted) {
        onCompleted(data.askForImmediateHelp?.ccsTeamTelephoneNumber);
      }
    },
  });

  const userIsLoggedIn = isLoggedIn();

  useEffect(() => {
    if (userIsLoggedIn) {
      askForImmediateHelp();
    }
  }, [userIsLoggedIn]);

  return {
    ccsPhoneNumber: data?.askForImmediateHelp?.ccsTeamTelephoneNumber,
  };
};
